export const ArrowBackIcon = ({ className }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 9.16631L5.34503 9.16631L9.75586 4.75548L8.57753 3.57715L2.15503 9.99965L8.57753 16.4221L9.75586 15.2438L5.34503 10.833L17.5 10.833V9.16631Z" fill="currentColor" />
    </svg>

  )
}